import React, { Component } from 'react';
import $ from "jquery";
import TopMenu from '../commonFiles/TopMenu';
import Spinner from '../commonFiles/Spinner';
import Footer from '../commonFiles/Footer';
class BlogView extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

componentDidMount(){
  $("html, body").animate({ scrollTop: 0 });
  window.menu_selection('/pro_bono_begal_help');
}


  render() {
    return (
        <div className="container-xxl page_background p-0">
          <Spinner/>
          <TopMenu title="Insights"/>
          <div className="container-xxl py-5">
              <div className="container inner_con">

                  <div className="row g-4 mb-5">
                      <h2 className="text-start mb-2 wow fadeInUp title_view" data-wow-delay="0.1s">Blogs</h2>

                      <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
                          <a className="cat-item cat_item_blog  rounded p-4" href="">
                          <div className="d-flex align-items-center mb-3">
                              <img className="img-fluid flex-shrink-0 rounded" src="/assets/img/carousel-1.jpg" />
                          </div>
                              <h5 className="mb-1">Blog Ttile</h5>
                              <small><i>Date: 12/02/2025</i></small>
                              <p className="mt-2">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                              <p className="mt-4 text-end"><small><i>Read More...</i></small></p>
                          </a>
                      </div>

                      <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
                          <a className="cat-item cat_item_blog  rounded p-4" href="">
                          <div className="d-flex align-items-center mb-3">
                              <img className="img-fluid flex-shrink-0 rounded" src="/assets/img/about_banner.jpg" />
                          </div>
                              <h5 className="mb-1">Blog Ttile</h5>
                              <small><i>Date: 12/02/2025</i></small>
                              <p className="mt-2">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                              <p className="mt-4 text-end"><small><i>Read More...</i></small></p>
                          </a>
                      </div>

                      <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
                          <a className="cat-item cat_item_blog  rounded p-4" href="">
                          <div className="d-flex align-items-center mb-3">
                              <img className="img-fluid flex-shrink-0 rounded" src="/assets/img/carousel-1.jpg" />
                          </div>
                              <h5 className="mb-1">Blog Ttile</h5>
                              <small><i>Date: 12/02/2025</i></small>
                              <p className="mt-2">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                              <p className="mt-4 text-end"><small><i>Read More...</i></small></p>
                          </a>
                      </div>

                      <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
                          <a className="cat-item cat_item_blog  rounded p-4" href="">
                          <div className="d-flex align-items-center mb-3">
                              <img className="img-fluid flex-shrink-0 rounded" src="/assets/img/about_banner.jpg" />
                          </div>
                              <h5 className="mb-1">Blog Ttile</h5>
                              <small><i>Date: 12/02/2025</i></small>
                              <p className="mt-2">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                              <p className="mt-4 text-end"><small><i>Read More...</i></small></p>
                          </a>
                      </div>





                   </div>
                   </div>
              </div>
          <Footer />
        </div>
    );
  }
}

export default BlogView;
